import React, {useReducer} from "react";
import {Outlet, ScrollRestoration} from 'react-router-dom';
import {GlobalContext, globalReducer, initReducerParams} from "./GlobalReducer";
import ErrorBoundary from "./ui/core/ErrorBoundary";
import ModalBackdrop from "./ui/core/ModalBackdrop";
import MetaParams from "./ui/core/MetaParams";
import Header from "./ui/core/header/Header";
import Breadcrumbs from "./ui/core/Breadcrumbs";
import CustomerBanner from "./ui/core/CustomerBanner";
import Footer from "./ui/core/footer/Footer";
import ObjectStorage from "./utils/ObjectStorage";
import FrontStats from "./utils/FrontStats";
import HeaderProgressBar from "./ui/core/HeaderProgressBar";


export default function App() {

    const [state, dispatch] = useReducer(globalReducer, [], () => {
        return initReducerParams;
    })

    return (
        <>
            <ErrorBoundary>
                <GlobalContext.Provider value={[state, dispatch]}>
                    {state.isLoading && <HeaderProgressBar />}
                    <Header />
                    <MetaParams/>
                    <ScrollRestoration/>
                    <ObjectStorage />
                    <FrontStats />
                    <main className="page">
                        <CustomerBanner />
                        <Breadcrumbs />
                        <Outlet/>
                    </main>
                    <Footer />
                    {state.showBackdrop && <ModalBackdrop/>}
                </GlobalContext.Provider>
            </ErrorBoundary>
        </>
    )
}